export default __webpack_public_path__ + "static/media/SVG_logo_dgc_1.c834a960.svg";